import React from "react";
import { BrainCircuit } from "../../../../assets/icons/BrainCircuit";
import { GearsIcon } from "../../../../assets/icons/GearsIcon";
import { ClipboardUser } from "../../../../assets/icons/ClipboardUser";
import styles from "./Tabs.module.scss";

export const Tabs = ({ activeTab, setActiveTab }) => {
  const tabs = ["База знаний", "Настройки", "Персонал"];

  const handleClick = (index) => {
    setActiveTab(index);
  };

  return (
    <div className={styles.tabsContainer} style={{ display: "flex" }}>
      {tabs.map((tab, index) => {
        const isActive = index === activeTab;
        return (
          <div
            key={index}
            className={`${styles.tab} ${isActive ? styles.active : ""}`}
            onClick={() => handleClick(index)}
          >
            {index === 0 && (
              <BrainCircuit size={16} fill={isActive ? "white" : "#6e6e73"} />
            )}
            {index === 1 && (
              <GearsIcon
                width={21}
                height={16}
                fill={isActive ? "white" : "#6e6e73"}
              />
            )}
            {index === 2 && (
              <ClipboardUser size={16} fill={isActive ? "white" : "#6e6e73"} />
            )}
            <span>{tab}</span>
          </div>
        );
      })}
    </div>
  );
};
